import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://kjhawxschtlhaamwigin.supabase.co'
const supabaseAnonKey = 'sb_publishable_KFgKw7rSHNTxEMBHIAhn6A_CvDUcZnW'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
